import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Typography from '@mui/material/Typography';

interface SheetPickerProps {
  sheets: string[];
  onSelectSheet: (sheetName: string) => void;
}

/**
 * SheetPicker renders a dropdown for selecting a sheet from a multi-sheet XLSX file.
 * On selection, it calls the provided callback with the chosen sheet name.
 */
const SheetPicker: React.FC<SheetPickerProps> = ({ sheets, onSelectSheet }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value) {
      onSelectSheet(value);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        This file contains multiple sheets. Please select one to continue.
      </Typography>
      <FormControl fullWidth size="small">
        <InputLabel id="sheet-picker-label">Select Sheet</InputLabel>
        <Select
          labelId="sheet-picker-label"
          id="sheet-picker"
          defaultValue=""
          label="Select Sheet"
          onChange={handleChange}
          data-testid="sheet-picker-select"
        >
          {sheets.map((sheet) => (
            <MenuItem key={sheet} value={sheet}>
              {sheet}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SheetPicker;
